import { Category } from "@/types/category";
import { Countdown } from "@/types/countdown";
import { Order } from "@/types/order";
import { Product } from "@/types/product";
import { unstable_cache as cache } from "next/cache";
import {
  mockCategories,
  mockProducts,
  mockOrders,
  mockCountdown,
  mockHeroBanners,
  mockHeroSliders,
  mockCoupons,
} from "./mocks";
import {
  fetchVendureFacets,
  fetchVendureProducts,
  UrlFacetParams,
} from "@/lib/vendure/client";
import { mapVendureProductToNextMerce } from "@/lib/vendure/model-maps";
import { VendureFacet, VendureProduct } from "@/lib/vendure/models";
import { defaultChannel } from "@/utils/default-channel";

export async function getCategories() {
  // Mock: zwróć wszystkie kategorie
  return mockCategories;
}

export async function getFacets(channel: string | null) {
  return fetchVendureFacets(channel);
}

export async function getCategoryBySlug(slug: string) {
  // Mock: znajdź kategorię po slug
  const category = mockCategories.find((cat) => cat.slug.current === slug);
  return category || mockCategories[0];
}

export async function getCategoryById(id: string) {
  // Mock: znajdź kategorię po id
  const category = mockCategories.find((cat) => cat._id === id);
  return category || mockCategories[0];
}

type PaginationArgs = {
  take: number;
  skip: number;
};

export async function getAllProducts(
  host: string | null,
  facets: VendureFacet[],
  params: UrlFacetParams,
  pagination: PaginationArgs
): Promise<{ totalItems: number; items: VendureProduct[] }> {
  const channel = host || defaultChannel;

  return fetchVendureProducts({
    take: pagination.take,
    skip: pagination.skip,
    channel,
    facets,
    params,
  });
}

export const getProductsByFilter = cache(
  async (query: string, tags: string[]) => {
    // Mock: podstawowe filtrowanie produktów
    // Można rozszerzyć logikę filtrowania w zależności od potrzeb
    return mockProducts;
  },
  ["filtered-products"],
  { tags: ["product"] }
);

export async function getAllProductsCount() {
  return 122;
}

export async function getProduct(slug: string) {
  // Mock: znajdź produkt po slug
  const product = mockProducts.find((prod) => prod.slug?.current === slug);
  return product || mockProducts[0];
}

export async function getHighestPrice() {
  // Mock: znajdź najwyższą cenę
  const prices = mockProducts.map((p) => p.price);
  return Math.max(...prices);
}

export async function getOrders(query: string) {
  // Mock: zwróć zamówienia
  // W prawdziwej implementacji można parsować query i filtrować
  return mockOrders;
}

// fetch unique orders by orderId
export async function getOrderById(orderId: string) {
  // Mock: znajdź zamówienie po orderId
  const order = mockOrders.find((order) => order.orderId === orderId);
  return order || mockOrders[0];
}

export const getHeroBanners = cache(
  async () => {
    // Mock: zwróć bannery hero
    return mockHeroBanners;
  },
  ["hero-banners"],
  { tags: ["heroBanner"] }
);

export const getHeroSliders = cache(
  async () => {
    // Mock: zwróć slidery hero
    return mockHeroSliders;
  },
  ["hero-sliders"],
  { tags: ["heroSlider"] }
);

export async function getCoupons() {
  // Mock: zwróć kupony
  return mockCoupons;
}

export async function getCountdown() {
  // Mock: zwróć countdown
  return mockCountdown;
}

export function imageBuilder(source: any) {
  if (typeof source === "string") {
    return {
      url: () => source,
      width: (w: number) => ({ url: () => source }),
      height: (h: number) => ({ url: () => source }),
      fit: (f: string) => ({ url: () => source }),
      auto: (a: string) => ({ url: () => source }),
    };
  }
  return {
    url: () => source?.asset?.url || "/images/placeholder.png",
    width: (w: number) => ({
      url: () => source?.asset?.url || "/images/placeholder.png",
    }),
    height: (h: number) => ({
      url: () => source?.asset?.url || "/images/placeholder.png",
    }),
    fit: (f: string) => ({
      url: () => source?.asset?.url || "/images/placeholder.png",
    }),
    auto: (a: string) => ({
      url: () => source?.asset?.url || "/images/placeholder.png",
    }),
  };
}
